/* Action names */
const SET_INTERNAL_NEWSLETTER_VISIBILITY = 'modules/manageModal/INTERNAL_NEWSLETTER_VISIBILITY';
const SET_INTERNAL_REGIONAL_VISIBILITY = 'modules/manageModal/INTERNAL_REGIONAL_VISIBILITY';

/* Types */
type ModalsActionType = typeof SET_INTERNAL_NEWSLETTER_VISIBILITY | typeof SET_INTERNAL_REGIONAL_VISIBILITY;

/* Interfaces */
interface ModalsPayload {
  internalNewsletter: { visible: boolean };
  internalRegional: { visible: boolean };
}

export interface ModalsState {
  internalNewsletter: { visible: boolean };
  internalRegional: { visible: boolean };
}

interface ModalsAction {
  payload: ModalsPayload;
  type: ModalsActionType;
}

/* Reducers */
const reducer = (
  state: ModalsState = { internalNewsletter: { visible: false }, internalRegional: { visible: false } },
  action: ModalsAction
) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INTERNAL_NEWSLETTER_VISIBILITY:
      return Object.assign({}, state, {
        internalNewsletter: Object.assign({}, state.internalNewsletter, {
          visible: payload.internalNewsletter.visible
        })
      });
    case SET_INTERNAL_REGIONAL_VISIBILITY:
      return Object.assign({}, state, {
        internalRegional: Object.assign({}, state.internalRegional, {
          visible: payload.internalRegional.visible
        })
      });
    default:
      return state;
  }
};

/* Actions */
const setNewsletterVisibility = (visible: boolean) => ({
  payload: { internalNewsletter: { visible } },
  type: SET_INTERNAL_NEWSLETTER_VISIBILITY
});

const setRegionalVisibility = (visible: boolean) => ({
  payload: { internalRegional: { visible } },
  type: SET_INTERNAL_REGIONAL_VISIBILITY
});

export { reducer as default, setNewsletterVisibility, setRegionalVisibility };
